import MuiButton, { ButtonProps as MuiButtonProps } from '@mui/material/Button'
import { useAuth } from 'hooks'
import React from 'react'
import { Link } from '../Link'

interface ButtonProps extends Omit<MuiButtonProps, 'href'> {
    can?: number | number[]
    href?: string | number
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
    ({ can: onlyView, href, ...props }, ref) => {
        const {
            decoded: { categoria },
        } = useAuth()

        if (onlyView) {
            if (typeof onlyView === 'number' && onlyView !== categoria) {
                return null
            }

            if (Array.isArray(onlyView) && !onlyView.includes(categoria)) {
                return null
            }
        }

        if (href) {
            return (
                <MuiButton
                    variant="contained"
                    color="primary"
                    {...props}
                    ref={ref}
                    component={Link as any}
                    href={href as string}
                />
            )
        }

        return (
            <MuiButton
                variant="contained"
                color="primary"
                {...props}
                ref={ref}
            />
        )
    },
)

Button.displayName = 'Button'
